import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useAppointments(onUnauthorized) {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const guard = useCallback((e, fallback) => {
    if (e.response?.status === 401) { onUnauthorized(); return; }
    toast.error(e.response?.data?.detail || fallback);
  }, [onUnauthorized]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/appointments");
      setAppointments(data);
    } catch (e) {
      guard(e, "No se pudieron cargar las citas.");
    } finally {
      setLoading(false);
    }
  }, [guard]);

  useEffect(() => { load(); }, [load]);

  const toggleStatus = async (a) => {
    const next = a.status === "confirmada" ? "pendiente" : "confirmada";
    try {
      await api.patch(`/appointments/${a.id}/status`, { status: next });
      toast.success(next === "confirmada" ? "Cita confirmada" : "Cita marcada como pendiente");
      load();
    } catch (e) {
      guard(e, "No se pudo actualizar el estado.");
    }
  };

  const remove = async (a) => {
    try {
      await api.delete(`/appointments/${a.id}`);
      toast.success(`Cita de ${a.nombre} eliminada`);
      load();
    } catch (e) {
      guard(e, "No se pudo eliminar la cita.");
    }
  };

  return { appointments, loading, load, toggleStatus, remove };
}
